import React from 'react'

// Material UI
import AppBar from '@material-ui/core/AppBar'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'

// Style
import { makeStyles } from '@material-ui/core/styles'

// Icons
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

// Translation
import { Language } from '../../Translation'

// Redux
import { connect } from 'react-redux'

const OrderConfirmation = ({ orderId, clientData, storeData }) => {

    const { store } = storeData
    const { language } = clientData

    const goToMenu = () => {
        window.location = store.CLIENT_REDIRECT_URL
    }

    const useStyles = makeStyles((theme) => ({
        footer: {
            backgroundColor: "#f5f5f5",
            position: "fixed",
            width: "100%",
            bottom: 0,
        },
        backToMenuButton: {
            width: "100%",
            backgroundColor: "#003366",
        },
        box: {
            textAlign: "center",
            marginBottom: 70,
        }
    }));

    const classes = useStyles()

    return (
        <>
            <AppBar style={{ position: 'static', backgroundColor: "#003366" }}>
                <Toolbar>
                    <Typography variant="h6">{Language.OrderConfirmationHeader[language]}</Typography>
                </Toolbar>
            </AppBar>
            <Box className={classes.box} p={6}>
                <Card>
                    <CardContent>
                        <>
                            <CheckCircleOutlineIcon style={{ color: "green", fontSize: "11rem" }} />
                            <br />
                            <br />
                            <Typography variant="h4">{Language.OrderConfirmationComplete[language]}</Typography>
                            <br />
                            <br />
                            <Typography variant="h3"># {orderId}</Typography>
                            <br />
                            <br />
                            <Typography variant="h4">{language === "fr" ? store.FINISH_FR : store.FINISH_EN}</Typography>
                        </>
                    </CardContent>
                </Card>
            </Box>
            <Card className={classes.footer}>
                <CardContent>
                    <Button className={classes.backToMenuButton} onClick={() => goToMenu()} variant="contained" size="large" >
                        <Typography style={{ color: "white" }}>{Language.OrderConfirmationComplete[language]}</Typography>
                    </Button>
                </CardContent>
            </Card>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        storeData: state.storeData,
        clientData: state.clientData
    }
}

export default connect(mapStateToProps)(OrderConfirmation)